import CohortBase from 'components/analytics/Cohort/CohortBase';
import { CohortSelector } from 'components/analytics/Cohort/CohortSelector';
import { BackToTop, DateSelector } from 'components/common';
import { ComposableFilters } from 'components/common/ComposableFilters';
import { SegmentSelector } from 'components/common/SegmentSelector';
import { ExternalLinkIcon } from 'components/icons';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router';
import { usePageTitle } from 'utils';
import { useAppSelector } from 'store';

export default function CustomerCohort() {
  usePageTitle('Customer cohorts | Segments');

  const { currentStore } = useAppSelector((state) => state.userDetails);

  let { path } = useRouteMatch();

  return (
    <div className="relative px-5 mx-auto max-w-screen-segments-1150px 2xl:max-w-screen-xl md:pl-segments-72px md:pr-20 py-11">
      <p className="font-bold leading-6">Analytics</p>

      <h1 className="mt-4 font-bold leading-10 text-segments-44px">
        Customer cohorts
      </h1>

      <p className="mt-3 text-black">
        Analyze customer profitability and follow-on spend by cohort.
      </p>

      <a
        href="https://help.tresl.co/en/articles/5395986-customer-cohorts"
        className="inline-flex items-start space-x-0.5 text-segments-link font-bold mt-2"
        target="_blank"
        rel="noreferrer"
      >
        <p>Learn more</p>
        <ExternalLinkIcon className="inline w-5 h-5 align-middle" />
      </a>
      <main id="cohort-page-export">
        <div className="relative flex items-center space-x-4 mt-7">
          <div className="w-full pl-5 pr-6 text-base border h-segments-60px bg-segments-accent-green-3 rounded-2xl border-">
            <div className="flex items-center justify-between h-full align-middle">
              <SegmentSelector />
              <ComposableFilters />
            </div>
          </div>
          <div className="2xl:flex-shrink-0">
            <DateSelector defaultPeriod="Last 365 days" />
          </div>
        </div>
        <p className="mt-1.5 text-segments-13px  text-black text-opacity-50">
          Important: the following analysis only considers valid orders.{' '}
          <a
            href="https://help.tresl.co/en/articles/5432306-valid-orders"
            className="inline-flex items-start space-x-0.5 text-segments-link font-bold mt-2"
            target="_blank"
            rel="noreferrer"
          >
            Read more
            <ExternalLinkIcon className="inline ml-0.5 w-4 h-4 align-middle" />
          </a>
        </p>
        <CohortSelector />

        <Switch>
          <Route exact path={path}>
            <Redirect
              to={{
                pathname: `${path}/revenue_growth`,
                search: currentStore.serializedStoreName,
              }}
            />
          </Route>
          <Route exact path={`${path}/revenue_growth`}>
            <CohortBase cohort_type="revenue_growth" />
          </Route>
          <Route exact path={`${path}/repeat_purchase`}>
            <CohortBase cohort_type="repeat_purchase" />
          </Route>
          <Route exact path={`${path}/churn_rate`}>
            <CohortBase cohort_type="churn_rate" />
          </Route>
        </Switch>
      </main>
      <BackToTop />
    </div>
  );
}
